// CMP-0127 · LFS Locations Search box · Catalog Engine · Lot Discovery · owner: Platform
// 99-1: /Users/yogeshmathur/ym/lot-for-sale-ph/docs/design-handoff/README.md
// 99-1-decision: REUSE the shared PlaceSuggest combobox (CMP-0107) on the Locations page; only the state holder is new
"use client"

import { useState } from "react"
import { PlaceSuggest } from "./place-suggest"
import type { PlaceHit } from "@/lib/lfs/places"

export function LocationsSearch({ places }: { places: PlaceHit[] }) {
  const [q, setQ] = useState("")
  return (
    <div style={{ position: "relative", maxWidth: 640 }}>
      <PlaceSuggest
        places={places}
        value={q}
        onChange={setQ}
        placeholder="Province, city, village or development — e.g. AAV, Tagaytay"
        ariaLabel="Search locations"
        // 99-1: /Users/yogeshmathur/ym/lot-for-sale-ph/docs/design-handoff/README.md
        // 99-1-decision: visible outline so the box reads as a search field on white pages (Not Found) as well as grey ones
        inputStyle={{ height: 56, fontSize: 17, borderRadius: 14, paddingLeft: 16, background: "#fff", border: "1px solid #CBD2DC" }}
      />
    </div>
  )
}
